// extracted by mini-css-extract-plugin
export default {"sticky":"OperatingExpensesForm_sticky__eWK-J"};